import * as z from "zod/v4";

export const createUpsGhostAccountLocationSchema = z.object({
  locationName: z.string(),
  pickupContactFirstName: z.string(),
  pickupContactLastName: z.string(),
  pickupBusinessName: z.string(),
  pickupPhone: z.string(),
  pickupEmail: z.string(),
  pickupAddressLine1: z.string(),
  pickupAddressLine2: z.string().nullish(),
  pickupCity: z.string(),
  pickupState: z.string(),
  pickupPostalCode: z.string(),
  pickupCountryCode: z.string(),
  originalAddressHash: z.string().nullish(),
});

export type CreateUpsGhostAccountLocationData = z.infer<
  typeof createUpsGhostAccountLocationSchema
>;

export const createUpsGhostAccount = {
  name: "createUpsGhostAccount" as const,
  input: createUpsGhostAccountLocationSchema,
  output: z.object({ success: z.boolean() }),
};
